<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this book:</p>
<ul>
<li><p>(and apologise to) my family, including my three beautiful children, for the time that I dedicated to my work and study; and</p></li>
<li><p>to those who assisted with proofreading the various drafts (e.g. Hiamy).</p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2099756b